import { createContext } from 'react';

export const BalContext = createContext();
export const IsLoggedInContext = createContext();